import React from 'react'

const FeatureHome = () => {
  return (
    <div className="max-w-[550px]max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
      <div>
        <h2 className=" h2 text-center mb-[70px] ">Why Tradly Platform</h2>
        <div className="grid    sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-x-[30px] gap-y-10  ">
          <div className="flex flex-col items-center justify-center gap-2  ">
            <div className=" flex-none h-10 w-10 rounded-full bg-gray-300" />
            <div className=" grow space-y-2 text-center">
              <p className="text-[16px] leading-[29px]   font-semibold">Deploy in days</p>
              <p className="ext-[16px] leading-[20px] font-normal w-[95%]">
              
              Test your business idea, add your branding assets. Launch in a matter of days to test your ideas.
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center gap-2  ">
            <div className=" flex-none h-10 w-10 rounded-full bg-gray-300" />
            <div className=" grow space-y-2 text-center">
              <p className="text-[16px] leading-[29px]   font-semibold">Focus on Growth</p>
              <p className="ext-[16px] leading-[20px] font-normal w-[95%]">
              Tradly make it easier for your growth marketing team to have important marketing and analytical tools installed.
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center gap-2  ">
            <div className=" flex-none h-10 w-10 rounded-full bg-gray-300" />
            <div className=" grow space-y-2 text-center">
              <p className="text-[16px] leading-[29px]   font-semibold">Less Risk</p>
              <p className="ext-[16px] leading-[20px] font-normal w-[95%]">
              Without building a tech team to build something and unexpected situations. ​Experience first with our test apps and show to your users
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center gap-2  ">
            <div className=" flex-none h-10 w-10 rounded-full bg-gray-300" />
            <div className=" grow space-y-2 text-center">
              <p className="text-[16px] leading-[29px]   font-semibold">NEW FEATURES every month</p>
              <p className="ext-[16px] leading-[20px] font-normal w-[95%]">
              All the fundamental market features are pre-built. And new stable features are getting released every month. 
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center gap-2  ">
            <div className=" flex-none h-10 w-10 rounded-full bg-gray-300" />
            <div className=" grow space-y-2 text-center">
              <p className="text-[16px] leading-[29px]   font-semibold">Simple to Advanced</p>
              <p className="ext-[16px] leading-[20px] font-normal w-[95%]">
                Evolving toolkits. Simple pre-built templates. Blocks based feature to customize the page. Advanced No-code Editor to customize CSS. Webhooks, Open API, JS SDK for developers.
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center gap-2  ">
            <div className=" flex-none h-10 w-10 rounded-full bg-gray-300" />
            <div className=" grow space-y-2 text-center">
              <p className="text-[16px] leading-[29px]   font-semibold">Social features pre-built</p>
              <p className="ext-[16px] leading-[20px] font-normal w-[95%]">
                Make your platform sticky. Social media like features. Tags. 
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeatureHome
